import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import "./style.css";
import CustomCard from "../../../dentail-indetifcation/components/d-reusable/CustomCard";
import { getFAQs } from "../../../components/https/age-assessment-apis";
import { errorRequestHandel } from "../../../helper";
import CustomSpinner from "../../../dentail-indetifcation/components/d-reusable/CustomSpiner";

const { Panel } = Collapse;

const FAQs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getFaqsData();
  }, []);
  const getFaqsData = async () => {
    try {
      setLoading(true);
      const response = await getFAQs({ limit: 1000 });
      if (response.status === 200) {
        setData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };
  return (
    <CustomCard>
      <CustomSpinner loading={loading} />
      <div className="fqs_container">
        <div className="fqs_body">
          <p className="_heading">FAQ's</p>
          <Collapse accordion>
            {data.map((faq, index) => (
              <Panel header={faq.question} key={index}>
                <p>{faq.answer}</p>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </CustomCard>
  );
};

export default FAQs;
